module.exports = __webpack_public_path__ + "static/media/TRENIT.f1ea6d39.svg";